type HostAdBanner = {
    isEnabledDesktop: boolean;
    isEnabledMobile: boolean;
};

type HostArgs = {
    id: number;
    template: string;
    adBanner: HostAdBanner;
};

export class Host {
    private static instance: Host;
    readonly id: number;
    readonly template: string;
    readonly adBanner: HostAdBanner;

    constructor(args: HostArgs) {
        const { id, template, adBanner } = args;

        this.id = id;
        this.template = template;
        this.adBanner = adBanner;
    }

    private static makeHostFromWindow(): Host {
        return new Host({
            id: window.__host__.id,
            template: window.__host__.template,
            adBanner: {
                isEnabledDesktop: Boolean(window.__host__.adbanner_desktop),
                isEnabledMobile: Boolean(window.__host__.adbanner_mobile),
            },
        });
    }

    public static getInstance(): Host {
        if (!Host.instance) {
            Host.instance = Host.makeHostFromWindow();
        }

        return Host.instance;
    }
}
